import React from 'react';

import PropTypes from 'prop-types';

import { StylableComponent, stylePropType } from '@adsk/alloy-react-helpers';
import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { variantPropType, FILE_HANDLER_VARIANTS, Variant } from '../consts';

type NameProps = StylableComponent<HTMLDivElement> & {
  variant?: Variant;
  disabled?: boolean;
};

const Name = React.forwardRef<HTMLDivElement, NameProps>(
  ({ className, style, variant, disabled, children, ...props }, ref) => (
    <div
      {...props}
      ref={ref}
      className={className}
      css={[
        theme.typography.bodyMedium,
        {
          height: 24,
          display: 'flex',
          alignItems: 'center',
          color: disabled ? theme.colors.charcoal500 : theme.colors.charcoal900,
          textDecoration:
            variant === FILE_HANDLER_VARIANTS.REMOVED ? 'line-through' : 'none',
        },
        style,
      ]}
    >
      <OverflowTooltip>{children}</OverflowTooltip>
    </div>
  )
);

Name.displayName = 'Name';
Name.defaultProps = {};

Name.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The style variant */
  variant: variantPropType,
  /** If the file is disabled (removed or loading variant) */
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

export default Name;
